<template>
  <div id="settings.login-policy">
    <article>
      <div class="w-100">
        <DomainsDataTable
          :title="translate('Owned Domains')"
          :loading="loginPolicyStore.domainsLoading"
          :rows="loginPolicyStore.domains"
          :style="{marginBottom: '2em'}"
          @delete="(id: string) => (domainIdToDelete = id)"
        />
        <DomainVerificationsDataTable
          :title="translate('Pending Verifications')"
          :loading="loginPolicyStore.domainVerificationsLoading"
          :rows="pendingVerifications"
          :style="{marginBottom: '2em'}"
          @delete="(id: string) => loginPolicyStore.removeDomainVerification(id)"
          @accept="(id: string) => (verificationIdToVerify = id)"
          @create="startDvDialogOpen = true"
        />
        <LoginPolicySettings />
      </div>
    </article>
    <DeleteDialog
      v-if="domainToDelete"
      :domain="domainToDelete"
      @close="domainIdToDelete = undefined"
    />
    <StartDomainVerificationDialog v-if="startDvDialogOpen" @close="startDvDialogOpen = false" />
    <SubmitVerificationCodeDialog
      v-if="verificationToVerify"
      :domain-verification="verificationToVerify"
      @close="verificationIdToVerify = undefined"
    />
  </div>
</template>
<script lang="ts" setup>
import {DomainVerification} from '@/api/apolloPlatform/loginPolicy';
import DeleteDialog from './DeleteDomainDialog.vue';
import DomainVerificationsDataTable from './DomainVerificationsDataTable.vue';
import {useLocalisation} from '@/composables/useLocalisation';

const {translate} = useLocalisation();

const loginPolicyStore = useLoginPolicyStore();

const pendingVerifications = computed(() =>
  loginPolicyStore.domainVerifications.filter((dv) => !dv.validated),
);

function getDomainById(id: string | undefined): Domain | undefined {
  return loginPolicyStore.domains.filter((d) => d.id === id)[0];
}
function getDvById(id: string | undefined): DomainVerification | undefined {
  return pendingVerifications.value.filter((d) => d.id === id)[0];
}

const startDvDialogOpen = ref(false);

const now = ref(new Date());
let interval: number | undefined;
onMounted(() => {
  interval = window.setInterval(() => {
    now.value = new Date();
  }, 1000);
});
onUnmounted(() => {
  clearInterval(interval);
});

const domainIdToDelete = ref<string>();
const verificationIdToVerify = ref<string>();
const domainToDelete = computed(() => getDomainById(domainIdToDelete.value));
const verificationToVerify = computed(() => {
  const verification = getDvById(verificationIdToVerify.value);
  if (!verification || verification.expired < now.value) return undefined;
  return verification;
});

onMounted(() => {
  loginPolicyStore.ensureDomainsLoaded();
  loginPolicyStore.ensureDomainVerificationsLoaded();
  loginPolicyStore.ensureLoginPoliciesLoaded();
});
</script>
